
import Vue from 'vue';
import { formatDateString } from '@util/dates-and-times';
import { Component, Prop } from 'vue-property-decorator';
import { FilterOptions } from '@util/types';
import { Pilot, Zone, Tag } from '@clients/myTrips';
import { namespace } from 'vuex-class';

const SettingsModule = namespace('Settings');

export type FilterType = 'date' | 'pilotId' | 'tagId' | 'zoneId' | 'errorsOnly';

interface FilterItem {
  name: string;
  type: FilterType;
}

@Component({
  name: 'TripFilterList'
})
export default class TripFilterList extends Vue {
  @Prop({ required: true })
  private filterOptions: FilterOptions

  @SettingsModule.Getter('getPilots')
  private pilots: Pilot[];

  @SettingsModule.Getter('getZones')
  private zones: Zone[];

  @SettingsModule.Getter('getTags')
  private tags: Tag[];

  get filters(): FilterItem[] {
    const filterItems: FilterItem[] = [];
    if (this.filterOptions.date && (this.filterOptions.date.from || this.filterOptions.date.until)) {
      const from = this.filterOptions.date.from;
      const until = this.filterOptions.date.until;
      let dateString;
      if (from && until) {
        dateString = `Datum: ${formatDateString(from)} - ${formatDateString(until)}`;
      } else if (from) {
        dateString = `Datum: ab ${formatDateString(from)}`;
      } else {
        dateString = `Datum: bis ${formatDateString(until)}`;
      }
      filterItems.push({ name: dateString, type: 'date' });
    }
    if (this.filterOptions.errorsOnly) {
      filterItems.push({ name: 'Nur Fehler', type: 'errorsOnly' })
    }
    if (this.filterOptions.pilotId) {
      const p = this.pilots.find(p => p.id === this.filterOptions.pilotId);
      if (p) {
        filterItems.push({ name: `Fahrer: ${p.lastname}`, type: 'pilotId' });
      }
    }
    if (this.filterOptions.tagId) {
      const t = this.tags.find(p => p.id === this.filterOptions.tagId);
      if (t) {
        filterItems.push({ name: `Kategorie: ${t.name}`, type: 'tagId' });
      }
    }
    if (this.filterOptions.zoneId) {
      const z = this.zones.find(p => p.id === this.filterOptions.zoneId);
      if (z) {
        filterItems.push({ name: `Ziel: ${z.name}`, type: 'zoneId' });
      }
    }
    return filterItems;
  }

  private removeFilter(filter: FilterItem) {
    const copy = new FilterOptions(this.filterOptions);
    if (filter.type === 'date') {
      copy.date.from = null;
      copy.date.until = null;
    } else if (filter.type === 'errorsOnly') {
      copy.errorsOnly = false;
    } else {
      copy[filter.type] = null;
    }
    this.$emit('input', copy);
  }

  private removeAllFilters() {
    this.$emit('input', FilterOptions.emptyFilters());
  }
}
